import React from 'react'
import SEO from '../components/SEO/SEO'
import Services from '../components/Services'
// import Packages from '../components/Packages'
import CTA from '../components/CTA'

const ServicesPage = () => {
  return (
    <div className="services-page" style={{ paddingTop: '80px' }}>
      <SEO
        title="Our Services - FIGO Digital Services | Software Development, AI & Digital Transformation"
        description="Explore our comprehensive digital services: Custom Software Development, AI & Automation, Digital Transformation, UI/UX Design, Data Analytics, Cybersecurity, and Digital Marketing in Nigeria."
        keywords="software development services, AI automation, digital transformation Nigeria, custom software, mobile app development, web development, UI/UX design, data analytics, cybersecurity Nigeria, digital marketing"
        url="https://figodigitalservices.com/services"
      />
      <div className="page-header" style={{ 
        background: 'var(--dark-surface)', 
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <h1 style={{ 
          fontFamily: 'var(--font-display)', 
          fontSize: 'clamp(2rem, 5vw, 3rem)',
          marginBottom: '1rem'
        }}>
          Our Services
        </h1>
        <p style={{ 
          color: 'var(--muted-text)', 
          maxWidth: '600px', 
          margin: '0 auto' 
        }}>
          Comprehensive digital solutions from strategy to execution
        </p>
      </div>
      <Services />
      {/* <Packages /> */}
      <CTA />
    </div>
  )
}

export default ServicesPage
